import Splide from '@splidejs/splide';

export default {

	init() {
		console.log('init slider...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	// Home hero slider
	bindEvents() {
		var elems = document.querySelectorAll('.splide.slider:not([data-splide-ignore])');

		if (elems.length) {
			elems.forEach(function (elem) {
				let slider = new Splide(elem, {
					type: 'loop',
					perPage: 1,
					autoWidth: false,
					arrows: false,
					pagination: true,
					trimSpace: true,
					autoplay: true,
					interval: 5000,
					pauseOnHover: false,
					pauseOnFocus: false,
				});

				slider.on('mounted', function() {
					Slider.updateSliderState(slider);
				});

				slider.on('moved', function() {
					Slider.updateSliderState(slider);
				});

                slider.mount();
			});
		}
	},

	updateSliderState(slider) {
		let allVideos = slider.root.querySelectorAll('.splide__slide video');
		let activeSlide = slider.Components.Slides.getAt(slider.index);
		let activeVideo = activeSlide.slide.querySelector('video');

		allVideos.forEach(function (video) {
			if (video === activeVideo) {
				video.play();
			} else {
				video.pause();
			}
		});
	},

};